import { ExternalLinkProps } from './helper';
import './ExternalLink.scss';

const ExternalLink = ({ text, href } : ExternalLinkProps) : JSX.Element => {
    return (
        <a target="_blank" rel="noopener noreferrer" className="external-link" href={href}>
            <h3>{text}</h3>
            <img src="/arrow_forward.svg" alt=""></img>
        </a>
    );
}

export default ExternalLink;